import { API } from "@/lib/apiClient";

// Fetch an admin export with auth and trigger a browser file download.
export const downloadExport = async (type, format) => {
  const token = localStorage.getItem("token");
  const res = await fetch(`${API}/admin/export/${type}?format=${format}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) {
    let detail = `Export failed (${res.status})`;
    try { const j = await res.json(); detail = j.detail || detail; } catch (e) { /* ignore */ }
    throw new Error(detail);
  }
  const blob = await res.blob();
  const headerName = res.headers.get("X-Filename");
  const ext = format === "json" ? "json" : "csv";
  const filename = headerName ? headerName.replace(/\.excel$/, ".csv") : `${type}_export.${ext}`;
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
